<template>
  <div class="exper-home">
    <div class="exper-home-title">
      <img
        :src="serverURL + 'images/theme/purple-red/exp_header_left.png'"
        alt=""
      />
      <p
        class="title"
        :class="[
          { setwidth: currentLan },
          getLocal() === 'zh'
            ? 'ZCOOL'
            : getLocal() === 'en'
            ? 'ZCOOL'
            : getLocal() === 'zh-hk'
            ? 'Noto'
            : '',
        ]"
      >
        {{ $t('lang.title.中华建筑文化海外传播虚拟仿真实验') }}
      </p>
      <img
        :src="serverURL + 'images/theme/purple-red/exp_header_right.png'"
        alt=""
      />
      <div class="exper-home-title-close" v-if='$route.query.five !== "true"'>
        <i class="el-icon-close" @click="closeExp"></i>
      </div>
    </div>
    <div class="exper-home-main" :style='$route.query.five === "true"?"left: 10%;":"left: 0;"'>
      <div
        class="exper-home-main-item"
        v-for="item in items"
        :key="item.id"
        v-show='$route.query.five !== "true" || item.five === true'
        @click="handleActive(item.path)"
      >
        <div class="key ZCOOL">{{item.id}}</div>
        <div class="image">
          <img :src="item.img" alt="" />
        </div>
        <p :class="{ setmh: !currentLan }">{{ $t(item.title) }}</p>
      </div>
    </div>
    <LanguageExperiment />
  </div>
</template>

<script>
import LanguageExperiment from '@/components/experimentation/languageLayout/language-experiment'
import { mapState } from 'vuex'
export default {
  name: 'exp-home',
  components: { LanguageExperiment },
  props: [],
  data() {
    return {
      items: [
        {
          id: 1,
          title: 'lang.index.mz',
          img: this.publicData.serverUrl + 'images/1.jpg',
          path: '/experimentation/experimentation1',
          five:true
        },
        {
          id: 2,
          title: 'lang.index.ct',
          img: this.publicData.serverUrl + 'images/2.jpg',
          path: '/experimentation/experimentation2',
          five:true
        },
        {
          id: 3,
          title: 'lang.index.mn',
          img: this.publicData.serverUrl + 'images/3.jpg',
          path: '/experimentation/experimentation3',
          five:true
        },
        {
          id: 4,
          title: 'lang.index.kh',
          img: this.publicData.serverUrl + 'images/4.jpg',
          path: '/experimentation/test',
          five:true
        },
        {
          id: 5,
          title: 'lang.index.sy',
          img: this.publicData.serverUrl + 'images/5.jpg',
          path: '/experimentation/report',
          five:false
        },
      ],
    }
  },
  watch: {},
  computed: {
    ...mapState(['translate_imgs', 'language_value']),
    serverURL() {
      return this.publicData.serverUrl
    },
    currentLan() {
      return this.language_value == 'zh'
      // return window.localStorage.getItem('translate') == 'zh'
    },
  },
  created() {},
  mounted() {},
  methods: {
    closeExp() {
      this.handleActive('/experiment')
    },
    getLocal() {
      return localStorage.getItem('translate')
    },
    handleActive(path) {
      if (path) {
        this.$router.push(path)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  color: var(--red-color);
  font-weight: bold;
  font-size: 40px;
  max-width: 1000px;
  text-align: center;
  text-shadow: 2px 1px var(--exp-color);
  line-height: 1.2;
  margin: 0;
  padding: 0 80px;
}
.setwidth {
  width: 558px;
}
.exper-home {
  &-title {
    width: 100%;
    padding-top: 9.5vh;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 6.66vh;
      &:nth-child(2) {
        height: 7.22vh;
        margin: 0 4vw;
      }
    }
    &-close {
      position: absolute;
      top: 3.148vh;
      right: 1.97916vw;
      height: 2.1vw;
      display: flex;
      align-items: center;
      i {
        width: 2.1vw;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.5vw;
        font-weight: bold;
        color: var(--exp-color);
        background-color: #f4f8fa;
        border-radius: 50%;
        &:hover {
          color: #fff;
          background-color: var(--exp-color);
          cursor: pointer;
        }
      }
    }
  }
  &-main {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;
    padding: 0 50px;
    display: flex;
    &-item {
      width: calc(20% - 2.6vw);
      margin: 1.3vw;
      position: relative;
      // min-height: 40.5vh;
      padding-top: 16%;
      padding-bottom: 3vh;
      color: var(--red-color);
      background-image: var(--exp_item_default);
      background-size: 100% 100%;
      display: flex;
      align-items: flex-end;
      &:hover {
        // padding: 0;
        color: var(--exp-color);
        background-image: var(--exp_item_active);
        background-size: 100% 100%;
        .key {
          color: var(--exp-color);
        }
      }
      .key {
        position: absolute;
        left: 50%;
        top: 8%;
        transform: translateX(-50%);
        font-size: 24px;
        font-weight: bold;
        color: var(--red-color);
      }
      .image {
        position: absolute;
        top: 20.5%;
        width: 100%;
        text-align: center;
        img {
          width: 95%;
          border-radius: 12px 12px 0 0;
          border-bottom: 2px solid;
          cursor: pointer;
        }
      }
      p {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin: 0;
        padding: 3vh 2vh 0;
        font-size: 1vw;
        font-weight: bold;
        cursor: pointer;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .setmh {
        min-height: 5rem;
      }
      img {
        width: 100%;
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .image {
    img {
      border-radius: 6px 6px 0 0 !important;
    }
  }
}
</style>
